import React, { useState, useEffect } from 'react';
import { Menu, Drawer, Button } from 'antd';
import {
  MenuOutlined,
  DownCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import '../Assets/css/TopMenu.css'; // Optional for additional styling

function TopMenu() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState('/');
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const updateMobileView = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    updateMobileView();
    window.addEventListener('resize', updateMobileView);
    return () => window.removeEventListener('resize', updateMobileView);
  }, []);

  const items = [
    {
      label: 'Home',
      key: '/',
    },
    {
      label: 'About Us',
      key: '/about',
      icon: <DownCircleOutlined />,
      children: [
        { label: 'Who We Are', key: '/who-we-are' },
        { label: 'Our Mission', key: '/our-mission' },
        { label: 'Organizational Structure', key: '/organizational-structure' },
        { label: 'Members', key: '/members' },
        { label: 'Achievement', key: '/achievement' },
      ]
    },
    {
      label: 'Department',
      key: '/department',
      icon: <DownCircleOutlined />,
      children: [
        { label: 'Marketing Procurement', key: '/marketing-procurement' },
        { label: 'Fertilizer / Inputs', key: '/fertilizer' },
        { label: 'Warehouse', key: '/ware-house' },
        { label: 'Engineering', key: '/engineering' },
      ]
    },
    {
      label: 'Notice / Tender',
      icon: <DownCircleOutlined />,
      children: [
        { label: 'Notice', key: '/notice' },
        { label: 'Tender', key: '/tenders' },
      ]
    },
    {
      label: 'Grievance',
      key: '/grievance',
    },
    {
      label: `MD's Desk`,
      key: '/management-desk',
    },
    {
      label: 'Download',
      icon: <DownCircleOutlined />,
      children: [
        { label: 'Forms', key: '/forms' },
        { label: 'Financial Statements', key: '/financial-statements' },
      ]
    },
    {
      label: 'Important Links',
      key: '/importantLinks',
    },
    {
      label: 'Available Products',
      key: '/available-product',
    },
    {
      label: 'Gallery',
      key: '/gallery',
    },
    {
      label: 'Contact Us',
      key: '/contact-us',
    }
  ];

  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
    if (isMobile) setDrawerVisible(false); // close drawer on mobile
  };

  return (
    <>
      {isMobile ? (
        <>
          <Button
            className="mobile-menu-button"
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setDrawerVisible(true)}
          />
          <Drawer
            title="Menu"
            placement="left"
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
            bodyStyle={{ padding: 0 }}
          >
            <Menu
              onClick={onClick}
              selectedKeys={[current]}
              mode="inline"
              items={items}
            />
          </Drawer>
        </>
      ) : (
        <Menu
          onClick={onClick}
          selectedKeys={[current]}
          mode="horizontal"
          items={items}
        />
      )}
    </>
  );
}

export default TopMenu;
